export default "__VITE_PUBLIC_ASSET__0d5add59__"